// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3kaeu","legacyBtn":"MutateMid_legacyBtn__14jV_"};